import type {
  IDependentControl,
  IDraggableControl,
  IRItemCard,
} from '~/presentation/reports/common/type';

import { InlineStack } from '@shopify/polaris';
import { DeleteAction } from './DeleteAction';
import { DragAction } from './DragAction';
import { ViewAction } from './ViewAction';

interface WrapperDragItemProps {
  draggable?: IDraggableControl;
  dependentControls?: IDependentControl[];
  uid?: string;
  info?: IRItemCard;
  onDelete?: () => void;
}

export const Actions: React.FC<WrapperDragItemProps> = ({
  draggable,
  dependentControls,
  uid,
  info,
  onDelete,
}) => {
  return (
    <InlineStack wrap={false} gap="100">
      <ViewAction info={info} />
      <DeleteAction dependentControls={dependentControls} uid={uid} onDelete={onDelete} />
      <DragAction draggable={draggable} />
    </InlineStack>
  );
};
